import { TextField } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import TableRow from "@material-ui/core/TableRow";
import CheckIcon from "@material-ui/icons/Check";
import ColorButton from "components/common/ColorButton";
import {
  Bagde,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import useModalLoading from "libs/hooks/useModalLoading";
import { getErrorMessage, isError, mapShareholder } from "libs/utils/form";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import {
  checkCompany,
  companySlice,
  selectCheckCompany,
} from "redux/modules/companySlice";
import { selectCurrentDocument } from "redux/modules/visaForm";

export default function CompanyInfoSection({
  formik,
  colSpan = 3,
  mapField = (str) => str,
  disabledBadge = false,
  isChangeMode = false,
  ConditionType,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [firstTimeChecked, setFirstTimeChecked] = useState(false);
  const { showLoading, hideLoading } = useModalLoading();
  const { isLoading } = useSelector(selectCurrentDocument);
  const { isSuccess, isFailure, data, error } = useSelector(selectCheckCompany);
  const canEdit = useSelector(canEditForm);
  const CompanyRegisterNumber =
    formik.values[mapField("CompanyRegisterNumber")];

  useEffect(() => {
    if (!firstTimeChecked) {
      dispatch(companySlice.actions.clearAll());
    }
  }, [firstTimeChecked]);

  useEffect(() => {
    if (isSuccess || isFailure) {
      hideLoading();

      if (isSuccess) {
        formik.setFieldValue(mapField("CompanyName"), data.companyName);
        formik.setFieldValue(mapField("CompanyAddress"), data.address);
        formik.setFieldValue(mapField("OfficeNumber"), data.phone);
        formik.setFieldValue(mapField("CompanyWebSite"), data.email);
        formik.setFieldValue(mapField("ProductService"), data.desc);
        formik.setFieldValue(
          mapField("Shareholder"),
          data?.shareholders
            ?.map((v) => ({
              shareholderId: null,
              nameOfCompany: v.name,
              sharesPercent: v.percent + "",
              nationalityID: v.nationality,
              status: true,
            }))
            .map(mapShareholder)
        );
      }
    }
  }, [isSuccess, isFailure]);

  useEffect(() => {
    if (isLoading) return;

    if (CompanyRegisterNumber && !firstTimeChecked) {
      showLoading();
      dispatch(checkCompany(CompanyRegisterNumber));
      setFirstTimeChecked(true);
    } else if (!firstTimeChecked) {
      setFirstTimeChecked(true);
    }
  }, [CompanyRegisterNumber, firstTimeChecked, isLoading]);

  // useEffect(() => {
  //   if (!firstTimeChecked) {
  //     setFirstTimeChecked(true);
  //   }
  // }, [firstTimeChecked]);

  const handleOnCheck = async () => {
    showLoading();
    dispatch(checkCompany(CompanyRegisterNumber));
  };

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={colSpan - 2}>
          <div className={classes.cellContent}>
            <div className={classes.flexRow} style={{ width: "100%" }}>
              {!disabledBadge && <Bagde number={1} />}
              <div className={classes.wrapField} style={{ marginRight: 15 }}>
                <InputLabel>Registered number</InputLabel>
                <TextField
                  disabled={!canEdit}
                  variant="outlined"
                  className={classes.textField}
                  InputProps={{
                    classes: {
                      root: isSuccess ? classes.textFieldSuccess : undefined,
                      notchedOutline: isSuccess
                        ? classes.notchedOutlineSuccess
                        : undefined,
                    },
                    endAdornment: isSuccess ? <CheckIcon /> : null,
                  }}
                  FormHelperTextProps={{
                    classes: {
                      root: isSuccess ? classes.textSuccess : undefined,
                    },
                  }}
                  // type="number"
                  name={mapField("CompanyRegisterNumber")}
                  value={formik.values[mapField("CompanyRegisterNumber")]}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isFailure}
                  helperText={isSuccess ? "success" : error?.message || " "}
                />
              </div>

              <ColorButton
                color="primary"
                variant="contained"
                disabled={!canEdit}
                onClick={handleOnCheck}
              >
                Check
              </ColorButton>
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            {!disabledBadge && <Bagde number={2} />}
            <div className={classes.wrapField}>
              <InputLabel>Company name</InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="CompanyName"
                value={formik.values.CompanyName}
                onChange={isChangeMode ? undefined : formik.handleChange}
                onBlur={isChangeMode ? undefined : formik.handleBlur}
                error={isError("CompanyName", formik)}
                helperText={getErrorMessage("CompanyName", formik)}
                disabled={
                  !isSuccess
                    ? true
                    : isChangeMode
                    ? ConditionType !== "CN"
                    : true || !canEdit
                }
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={2} rowSpan={2}>
          <div className={classes.cellContent}>
            {!disabledBadge && <Bagde number={3} />}
            <div className={classes.wrapField}>
              <InputLabel>Address</InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name={mapField("CompanyAddress")}
                value={formik.values[mapField("CompanyAddress")]}
                onChange={isChangeMode ? undefined : formik.handleChange}
                onBlur={isChangeMode ? undefined : formik.handleBlur}
                error={isError(mapField("CompanyAddress"), formik)}
                helperText={getErrorMessage(mapField("CompanyAddress"), formik)}
                disabled={
                  !isSuccess
                    ? true
                    : isChangeMode
                    ? ConditionType !== "CA"
                    : true
                }
                multiline
                rows={5}
                rowsMin={5}
                rowsMax={5}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={colSpan - 2}>
          <div className={classes.cellContent}>
            {!disabledBadge && <Bagde number={4} />}
            <div className={classes.wrapField}>
              <InputLabel>Office number</InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="OfficeNumber"
                value={formik.values.OfficeNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("OfficeNumber", formik)}
                helperText={getErrorMessage("OfficeNumber", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={colSpan - 2}>
          <div className={classes.cellContent}>
            {!disabledBadge && <Bagde number={5} />}
            <div className={classes.wrapField}>
              <InputLabel>Company website or e-mail address</InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name={mapField("CompanyWebSite")}
                value={formik.values[mapField("CompanyWebSite")]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(mapField("CompanyWebSite"), formik)}
                helperText={getErrorMessage(mapField("CompanyWebSite"), formik)}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
